export default "__VITE_ASSET__Dafk25Su__"